import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { scrollToSection } from '../utils/scrollUtils';

const PRODUCT_LINKS = [
  { key: 'problem', label: '課題' },
  { key: 'features', label: '主要機能' },
  { key: 'screens', label: '実際の画面' },
  { key: 'reasons', label: '選ばれる理由' },
  { key: 'pricing', label: '料金プラン' },
];

const SUPPORT_LINKS = [
  { key: 'flow', label: 'ご利用の流れ' },
  { key: 'faq', label: 'よくあるご質問' },
  { key: 'company', label: '会社概要' },
];

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  /** 規約ページからでもトップの該当セクションへ移動できるようにする */
  const go = (key: string) => {
    if (pathname !== '/') {
      navigate('/');
      window.setTimeout(() => scrollToSection(key), 120);
    } else {
      scrollToSection(key);
    }
  };

  return (
  <footer className="bg-ink-900 text-ink-200">
    <div className="container-content py-16">
      <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.3fr]">
        {/* ブランド */}
        <div>
          <div className="flex items-baseline gap-1">
            <span className="text-2xl font-black tracking-tight text-brand-500">サクミエ</span>
            <span className="text-lg font-bold text-white">会計</span>
          </div>
          <p className="mt-4 text-small leading-relaxed text-ink-300">
            中小企業のためのAI内蔵型会計システム。
            <br />
            外部接続不要・データは100%社内保存。
          </p>
          <a href="/monitor.html" className="btn btn-md btn-primary mt-6">
            30日間無料体験を申し込む
          </a>
        </div>

        {/* 製品 */}
        <nav aria-label="製品">
          <h2 className="text-small font-bold text-white">製品</h2>
          <ul className="mt-4 space-y-3">
            {PRODUCT_LINKS.map((l) => (
              <li key={l.key}>
                <button
                  onClick={() => go(l.key)}
                  className="text-small text-ink-300 transition-colors hover:text-white"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        {/* サポート */}
        <nav aria-label="サポート">
          <h2 className="text-small font-bold text-white">サポート</h2>
          <ul className="mt-4 space-y-3">
            {SUPPORT_LINKS.map((l) => (
              <li key={l.key}>
                <button
                  onClick={() => go(l.key)}
                  className="text-small text-ink-300 transition-colors hover:text-white"
                >
                  {l.label}
                </button>
              </li>
            ))}
            <li>
              <a
                href="/monitor.html"
                className="text-small text-ink-300 transition-colors hover:text-white"
              >
                お問い合わせ
              </a>
            </li>
          </ul>
        </nav>

        {/* 運営会社 */}
        <div>
          <h2 className="text-small font-bold text-white">運営会社</h2>
          <address className="mt-4 space-y-3 text-small not-italic text-ink-300">
            <p>
              <a
                href="https://myoaku.com"
                className="font-bold text-white transition-colors hover:text-brand-400"
              >
                オーアーク株式会社
              </a>
            </p>
            <p className="leading-relaxed">
              〒132-0013
              <br />
              東京都江戸川区江戸川2丁目30-6
              <br />
              小倉荘201号室
            </p>
          </address>
        </div>
      </div>

      <div className="mt-14 flex flex-col-reverse items-center gap-5 border-t border-white/10 pt-8 md:flex-row md:justify-between">
        <p className="text-small text-ink-400">
          © {new Date().getFullYear()} オーアーク株式会社 All rights reserved.
        </p>
        <nav aria-label="法令・規約" className="flex flex-wrap justify-center gap-x-5 gap-y-2">
          <Link to="/privacy" className="text-small text-ink-300 transition-colors hover:text-white">
            プライバシーポリシー
          </Link>
          <span className="text-white/20" aria-hidden="true">|</span>
          <Link to="/legal" className="text-small text-ink-300 transition-colors hover:text-white">
            特定商取引法に基づく表記
          </Link>
        </nav>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
